/**
 * Master Muscles — display currency (BHD/SAR) + country auto-switch
 */
(function () {
  'use strict';

  function readConfig() {
    var el = document.getElementById('mm-currency-config');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function readCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value, days) {
    if (!value || days === 0) {
      document.cookie = name + '=; path=/; max-age=0; SameSite=Lax';
      return;
    }
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; path=/; max-age=' +
      (days || 365) * 86400 +
      '; SameSite=Lax';
  }

  function lsGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function lsSet(key, val) {
    try {
      if (val == null) localStorage.removeItem(key);
      else localStorage.setItem(key, val);
    } catch (e) {}
  }

  var cfg = readConfig();
  var html = document.documentElement;
  var sarCountries = (cfg.sarCountries || ['SA', 'AE', 'KW', 'OM', 'QA'])
    .map(function (c) {
      return String(c).trim().toUpperCase();
    })
    .filter(Boolean);

  var divisor =
    cfg.divisor ||
    parseInt(html.getAttribute('data-mm-money-divisor'), 10) ||
    100;
  if (divisor !== 100 && divisor !== 1000) divisor = 100;
  html.setAttribute('data-mm-money-divisor', String(divisor));

  function readRate() {
    var fromHtml = parseFloat(String(html.getAttribute('data-mm-exchange-rate') || '').replace(',', '.'));
    if (!isNaN(fromHtml) && fromHtml > 0) return fromHtml;
    var fromCfg = parseFloat(String(cfg.rate || '10').replace(',', '.'));
    return !isNaN(fromCfg) && fromCfg > 0 ? fromCfg : 10;
  }

  function isManual() {
    return lsGet('mm_currency_manual') === '1' || readCookie('mm_currency_manual') === '1';
  }

  function setManual(on) {
    if (on) {
      lsSet('mm_currency_manual', '1');
      writeCookie('mm_currency_manual', '1');
    } else {
      lsSet('mm_currency_manual', null);
      writeCookie('mm_currency_manual', '', 0);
    }
  }

  function currencyForCountry(iso) {
    var code = String(iso || '').trim().toUpperCase();
    if (!code) return cfg.themeCurrency || 'BHD';
    if (code === 'BH') return 'BHD';
    if (sarCountries.indexOf(code) >= 0) return 'SAR';
    return 'BHD';
  }

  function getCountryIso() {
    return html.getAttribute('data-mm-country') || cfg.country || 'BH';
  }

  function getEffectiveCurrency() {
    if (isManual()) {
      var u = lsGet('mm_display_currency_user') || readCookie('mm_display_currency_user');
      if (u === 'BHD' || u === 'SAR') return u;
    }
    return currencyForCountry(getCountryIso());
  }

  function applyTax(minor) {
    if (window.mmTaxConfig && window.mmTaxConfig.enabled) {
      return Math.round(window.mmTaxConfig.applyTax(minor));
    }
    return minor;
  }

  function getDivisor(override) {
    var d = parseInt(override, 10);
    if (d === 100 || d === 1000) return d;
    return divisor;
  }

  function formatSar(minor, divOverride) {
    var div = getDivisor(divOverride);
    var rate = readRate();
    var major = (minor / div) * rate;
    var str = major.toFixed(cfg.decimals && cfg.decimals.SAR != null ? cfg.decimals.SAR : 2);
    var sym = (cfg.symbols && cfg.symbols.SAR) || 'SAR';
    var ar = html.lang && html.lang.indexOf('ar') === 0;
    return ar ? str + ' ' + sym : sym + ' ' + str;
  }

  function formatBhd(minor, divOverride) {
    var div = getDivisor(divOverride);
    var dec = cfg.bhdDecimals != null ? cfg.bhdDecimals : 3;
    var major = minor / div;
    var sym = (cfg.symbols && cfg.symbols.BHD) || 'BHD';
    var str = major.toFixed(dec);
    var ar = html.lang && html.lang.indexOf('ar') === 0;
    return ar ? str + ' ' + sym : sym + ' ' + str;
  }

  function formatMinor(minor, divOverride) {
    minor = parseInt(minor, 10) || 0;
    var taxed = applyTax(minor);
    if (getEffectiveCurrency() === 'SAR' && cfg.sarEnabled !== false) {
      return formatSar(taxed, divOverride);
    }
    return formatBhd(taxed, divOverride);
  }

  function parseShippingRateToBhdMinor(rate) {
    if (!rate) return null;
    var raw =
      rate.price != null ? rate.price : rate.price_min != null ? rate.price_min : rate.presentment_price;
    if (raw == null || raw === '') return null;

    var rateCurrency = String(rate.currency || rate.currency_code || '').toUpperCase();
    var div = getDivisor();

    if (typeof raw === 'number') {
      if (rateCurrency === 'SAR') {
        var sarMajorFromMinor = raw / 100;
        return Math.round((sarMajorFromMinor / readRate()) * div);
      }
      return raw;
    }

    var s = String(raw).trim();
    var numMatch = s.replace(/,/g, '').match(/([\d]+(?:\.\d+)?)/);
    if (!numMatch) return null;
    var major = parseFloat(numMatch[1]);
    if (isNaN(major)) return null;

    if (/SAR|ر\.س|ريال/i.test(s) || rateCurrency === 'SAR') {
      return Math.round((major / readRate()) * div);
    }

    return Math.round(major * div);
  }

  window.mmFormatShippingRate = function (rate, opts) {
    opts = opts || {};
    var minor = parseShippingRateToBhdMinor(rate);
    if (minor == null) return '';

    var targetCountry = String(opts.country || getCountryIso() || '').toUpperCase();
    var forceSar =
      opts.displayCurrency === 'SAR' ||
      targetCountry === 'SA' ||
      (sarCountries.indexOf(targetCountry) >= 0 && cfg.sarEnabled !== false);

    if (forceSar && cfg.sarEnabled !== false) {
      return formatSar(minor, opts.divisor);
    }
    if (getEffectiveCurrency() === 'SAR' && cfg.sarEnabled !== false) {
      return formatSar(minor, opts.divisor);
    }
    return formatBhd(minor, opts.divisor);
  };

  function persistCurrency(code, manual) {
    if (code !== 'BHD' && code !== 'SAR') return;
    setManual(!!manual);
    lsSet('mm_display_currency_user', code);
    writeCookie('mm_display_currency_user', code);
    html.setAttribute('data-mm-currency', code);
    syncSelects(code);
    window.dispatchEvent(new CustomEvent('mm:currency-change'));
  }

  function syncSelects(code) {
    document.querySelectorAll('[data-mm-theme-currency]').forEach(function (sel) {
      if (sel.tagName === 'SELECT') sel.value = code;
    });
  }

  function refreshPrices() {
    var cur = getEffectiveCurrency();
    html.setAttribute('data-mm-currency', cur);

    document.querySelectorAll('.mm-taxed-price[data-original-price]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-original-price'), 10);
      if (isNaN(n)) return;
      var elDiv = el.getAttribute('data-mm-divisor');
      el.textContent = formatMinor(n, elDiv);
      el.setAttribute('data-mm-currency', cur);
    });

    document.querySelectorAll('[data-mm-price-minor]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-mm-price-minor'), 10);
      if (isNaN(n)) return;
      el.textContent = formatMinor(n);
      el.setAttribute('data-mm-currency', cur);
    });
  }

  function applyCountryCurrency(iso, opts) {
    opts = opts || {};
    if (opts.clearManual) setManual(false);
    var code =
      opts.currency ||
      currencyForCountry(iso);
    persistCurrency(code, false);
    html.setAttribute('data-mm-country', iso);
    return code;
  }

  function prefixFromSelect(selectEl, suffix) {
    if (!selectEl || !selectEl.id) return '';
    return selectEl.id.replace(new RegExp('-' + suffix + '$'), '');
  }

  function submitLocalizationForm(prefix) {
    var form = document.getElementById(prefix + '-form');
    if (!form) return false;
    var countrySel = document.getElementById(prefix + '-country');
    var langSel = document.getElementById(prefix + '-lang');
    var countryInput = document.getElementById(prefix + '-country-input');
    var localeInput = document.getElementById(prefix + '-locale-input');
    if (countrySel && countryInput) countryInput.value = countrySel.value;
    if (langSel && localeInput) {
      localeInput.value = langSel.value;
    } else if (localeInput && cfg.language) {
      localeInput.value = cfg.language;
    }
    if (window.MMShop && typeof window.MMShop.updateReturnToOnForm === 'function') {
      window.MMShop.updateReturnToOnForm(form);
    }
    try {
      lsSet('mm_locale_popup_done', '1');
    } catch (e) {}
    form.submit();
    return true;
  }

  function onCountryChange(selectEl) {
    var prefix = prefixFromSelect(selectEl, 'country');
    var opt = selectEl.options[selectEl.selectedIndex];
    var iso = selectEl.value;
    var nextCur =
      (opt && opt.getAttribute('data-mm-country-currency')) || currencyForCountry(iso);

    applyCountryCurrency(iso, { clearManual: true, currency: nextCur });
    refreshPrices();

    submitLocalizationForm(prefix);
  }

  function onCurrencyChange(selectEl) {
    persistCurrency(selectEl.value, true);
    refreshPrices();
  }

  window.mmCurrencyConfig = {
    sarCountries: sarCountries,
    currencyForCountry: currencyForCountry,
    getEffectiveCurrency: getEffectiveCurrency,
    isManualCurrency: isManual,
    setUserCurrency: function (code, manual) {
      persistCurrency(code, manual === true);
    },
    applyCountryCurrency: applyCountryCurrency,
    syncAllCurrencySelects: syncSelects,
    formatDisplay: formatMinor,
    formatWithTax: formatMinor,
    formatExTax: formatMinor,
    refreshPrices: refreshPrices,
  };

  window.mmFormatMoney = function (n) {
    return formatMinor(n);
  };

  window.mmFormatMoneyHtml = function (n) {
    n = parseInt(n, 10) || 0;
    return (
      '<span class="mm-taxed-price" data-original-price="' +
      n +
      '">' +
      formatMinor(n) +
      '</span>'
    );
  };

  /** Format minor units that already include tax (for progress messages, no double tax). */
  window.mmFormatMoneyTaxed = function (taxedMinor, divOverride) {
    taxedMinor = parseInt(taxedMinor, 10) || 0;
    if (getEffectiveCurrency() === 'SAR' && cfg.sarEnabled !== false) {
      return formatSar(taxedMinor, divOverride);
    }
    return formatBhd(taxedMinor, divOverride);
  };

  window.mmRefreshAllPrices = refreshPrices;

  window.mmMarketsSubmitLocalization = function (fromPrefix) {
    var cCountry = document.getElementById(fromPrefix + '-country');
    var cLang = document.getElementById(fromPrefix + '-lang');
    var cSel = document.getElementById(fromPrefix + '-currency');
    var needsNav = false;

    if (cCountry && cCountry.value !== cfg.country) needsNav = true;
    if (cLang && cLang.value !== cfg.language) needsNav = true;

    if (cCountry) {
      var opt = cCountry.options[cCountry.selectedIndex];
      var iso = cCountry.value;
      var nextCur =
        (opt && opt.getAttribute('data-mm-country-currency')) ||
        currencyForCountry(iso);
      applyCountryCurrency(iso, { clearManual: true, currency: nextCur });
    } else if (cSel) {
      persistCurrency(cSel.value, true);
    }

    refreshPrices();

    if (needsNav) {
      var countryChanged = cCountry && cCountry.value !== cfg.country;
      var langChanged = cLang && cLang.value !== cfg.language;
      if (!countryChanged && langChanged && window.MMShop && typeof window.MMShop.switchLocale === 'function') {
        try {
          lsSet('mm_locale_popup_done', '1');
        } catch (e) {}
        window.MMShop.switchLocale(cLang.value);
        return;
      }
      submitLocalizationForm(fromPrefix);
      return;
    }
    try {
      lsSet('mm_locale_popup_done', '1');
    } catch (e) {}
  };

  function boot() {
    if (!isManual()) {
      applyCountryCurrency(getCountryIso(), { clearManual: false });
    } else {
      var cur = getEffectiveCurrency();
      syncSelects(cur);
      html.setAttribute('data-mm-currency', cur);
    }
    refreshPrices();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-mm-markets-country]')) {
      onCountryChange(t);
      return;
    }
    if (t.matches('[data-mm-theme-currency]')) {
      onCurrencyChange(t);
    }
  });

  window.addEventListener('mm:currency-change', refreshPrices);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.dispatchEvent(new CustomEvent('mm:currency-ready'));
})();
